(()=>{
  'use strict';

  function init(root=document){
    const track=root.querySelector('[data-wh-track]');

    if(track&&!track.dataset.ready){
      track.dataset.ready='true';

      const section=track.closest('section');
      const prev=section.querySelector('[data-wh-prev]');
      const next=section.querySelector('[data-wh-next]');

      const update=()=>{
        prev.disabled=track.scrollLeft<2;
        next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
      };

      const move=direction=>track.scrollBy({
        left:direction*track.clientWidth*.85,
        behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'
      });

      prev.addEventListener('click',()=>move(-1));
      next.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',update,{passive:true});
      new ResizeObserver(update).observe(track);
      update();
    }

    const mobile=matchMedia('(max-width:749px)');
    const groups=root.querySelectorAll('.wh-footer .wh-footer-links>details');

    groups.forEach(d=>{d.open=!mobile.matches;});
    mobile.addEventListener('change',e=>groups.forEach(d=>{d.open=!e.matches;}));
  }

  init();
  document.addEventListener('shopify:section:load',e=>init(e.target));

  const header=document.querySelector('.section-header');

  if(header){
    let queued=false;

    const update=()=>{
      header.classList.toggle('wh-scrolled',scrollY>20);
      queued=false;
    };

    addEventListener('scroll',()=>{
      if(!queued){
        queued=true;
        requestAnimationFrame(update);
      }
    },{passive:true});

    update();
  }
})();

(()=>{
  'use strict';
  let opener=null;

  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-wh-review-open]');

    if(button){
      const section=button.closest('.wh-customer-stories');
      const dialog=section?.querySelector('[data-wh-review-dialog]');
      const source=document.getElementById(button.dataset.whReviewOpen);

      if(!dialog||!source||typeof dialog.showModal!=='function')return;

      opener=button;
      dialog.querySelector('[data-wh-review-body]').replaceChildren(
        source.content.cloneNode(true)
      );
      dialog.scrollTop=0;
      dialog.showModal();
      document.documentElement.classList.add('wh-review-open');

      if(!matchMedia('(prefers-reduced-motion: reduce)').matches){
        dialog.animate(
          [
            {opacity:0,transform:'translateY(12px)'},
            {opacity:1,transform:'translateY(0)'}
          ],
          {duration:180,easing:'ease-out'}
        );
      }

      return;
    }

    const closer=event.target.closest('[data-wh-review-close]');

    if(closer){
      closer.closest('dialog')?.close();
      return;
    }

    const thumb=event.target.closest('[data-wh-review-image]');

    if(thumb){
      const dialog=thumb.closest('dialog');
      dialog.querySelector('.wh-review-full-photo').src=thumb.dataset.whReviewImage;
      dialog.querySelectorAll('[data-wh-review-image]').forEach(item=>
        item.setAttribute('aria-pressed',String(item===thumb))
      );
      return;
    }

    if(event.target.matches('[data-wh-review-dialog]')){
      const dialog=event.target;
      const rect=dialog.getBoundingClientRect();

      if(
        event.clientX<rect.left||
        event.clientX>rect.right||
        event.clientY<rect.top||
        event.clientY>rect.bottom
      ){
        dialog.close();
      }
    }
  });

  document.addEventListener('close',event=>{
    if(!event.target.matches('[data-wh-review-dialog]'))return;

    document.documentElement.classList.remove('wh-review-open');
    opener?.focus({preventScroll:true});
  },true);
})();

(()=>{
  'use strict';

  const dialog=document.querySelector('#WhPolicyDialog');
  if(!dialog||typeof dialog.showModal!=='function')return;

  const body=dialog.querySelector('[data-wh-policy-body]');
  const title=dialog.querySelector('#WhPolicyTitle');
  let opener=null;
  let closing=false;

  const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;

  const close=async()=>{
    if(closing||!dialog.open)return;
    closing=true;

    if(!reduced()){
      await dialog.animate(
        [
          {opacity:1,transform:'translateY(0)'},
          {opacity:0,transform:'translateY(12px)'}
        ],
        {duration:150,easing:'ease-in'}
      ).finished.catch(()=>{});
    }

    dialog.close();
  };

  dialog.addEventListener('close',()=>{
    document.documentElement.classList.remove('wh-policy-open');
    closing=false;
    opener?.focus({preventScroll:true});
  });

  dialog.addEventListener('cancel',e=>{
    e.preventDefault();
    close();
  });

  dialog.querySelectorAll('[data-wh-policy-close]').forEach(b=>
    b.addEventListener('click',close)
  );

  dialog.addEventListener('click',e=>{
    if(e.target===dialog){
      const r=dialog.getBoundingClientRect();

      if(
        e.clientX<r.left||
        e.clientX>r.right||
        e.clientY<r.top||
        e.clientY>r.bottom
      ){
        close();
      }
    }
  });

  document.addEventListener('click',e=>{
    const link=e.target.closest('a[href]');

    if(
      !link||
      e.defaultPrevented||
      e.metaKey||
      e.ctrlKey||
      e.shiftKey||
      e.altKey||
      e.button!==0
    )return;

    if(!link.closest('.wh-home,.wh-footer,.wh-service-strip,.wh-policy-dialog'))return;

    const url=new URL(link.href,location.href);
    if(url.origin!==location.origin)return;

    const handle=url.pathname.split('/').filter(Boolean).pop();
    if(!['shipping','returns','warranty'].includes(handle))return;

    const source=document.querySelector(`template[data-wh-policy="${handle}"]`);
    if(!source)return;

    e.preventDefault();

    if(!dialog.open)opener=link;

    title.textContent=source.dataset.title;
    body.replaceChildren(source.content.cloneNode(true));
    body.scrollTop=0;

    if(!dialog.open){
      dialog.showModal();
      document.documentElement.classList.add('wh-policy-open');

      if(!reduced()){
        dialog.animate(
          [
            {opacity:0,transform:'translateY(16px)'},
            {opacity:1,transform:'translateY(0)'}
          ],
          {duration:230,easing:'cubic-bezier(.2,.8,.2,1)'}
        );
      }
    }
  });

  /* Animate disclosure height, including reversal of an in-flight transition. */
  document.addEventListener('click',e=>{
    const summary=e.target.closest(
      '.wh-footer .wh-footer-links>details>summary,.wh-policy-dialog details>summary'
    );

    if(!summary)return;

    const detail=summary.parentElement;

    if(detail.closest('.wh-footer')&&!matchMedia('(max-width:749px)').matches){
      e.preventDefault();
      return;
    }

    if(reduced())return;

    e.preventDefault();

    const start=detail.getBoundingClientRect().height;
    const opening=detail.dataset.expanding
      ?detail.dataset.expanding!=='true'
      :!detail.open;

    detail.getAnimations().forEach(a=>a.cancel());
    detail.style.height='';
    detail.open=true;

    const end=opening
      ?detail.getBoundingClientRect().height
      :summary.getBoundingClientRect().height;

    detail.dataset.expanding=String(opening);
    detail.style.overflow='hidden';

    const animation=detail.animate(
      {height:[`${start}px`,`${end}px`]},
      {duration:220,easing:'cubic-bezier(.2,.8,.2,1)'}
    );

    animation.onfinish=()=>{
      detail.open=opening;
      detail.style.height='';
      detail.style.overflow='';
      delete detail.dataset.expanding;
    };
  });
})();